import { apiUpload } from "./apiClient";
import { Capacitor } from "@capacitor/core";

const APP_CONTEXT_EVENT = "aileAppContext";

function fallbackContext() {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  return {
    platform: Capacitor.getPlatform(),
    appVersion: process.env.REACT_APP_VERSION || "1.0",
    buildNumber: "",
    osVersion: ua,
    deviceModel: navigator.platform || "",
  };
}

export function getAppContext() {
  const handler = window.webkit?.messageHandlers?.aileNativeBridge;
  if (!handler) return Promise.resolve(fallbackContext());

  const callbackId = `feedback-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  return new Promise((resolve) => {
    let settled = false;
    const finish = (value) => {
      if (settled) return;
      settled = true;
      window.removeEventListener(APP_CONTEXT_EVENT, onContext);
      window.clearTimeout(timeoutId);
      resolve({ ...fallbackContext(), ...(value || {}) });
    };
    const onContext = (event) => {
      if (event?.detail?.callbackId !== callbackId) return;
      finish(event.detail);
    };
    const timeoutId = window.setTimeout(() => finish(null), 1200);
    window.addEventListener(APP_CONTEXT_EVENT, onContext);
    try {
      handler.postMessage({ action: "getAppContext", callbackId });
    } catch {
      finish(null);
    }
  });
}

export async function submitFeedback({ familyId, category, message, screenshots = [], language = "tr" }) {
  const appContext = await getAppContext();
  const form = new FormData();
  form.append("familyId", String(familyId || ""));
  form.append("category", String(category || ""));
  form.append("message", String(message || ""));
  form.append("language", language === "en" ? "en" : "tr");
  form.append("platform", appContext.platform || "ios");
  form.append("appVersion", appContext.appVersion || "");
  form.append("buildNumber", appContext.buildNumber || "");
  form.append("osVersion", appContext.osVersion || "");
  form.append("deviceModel", appContext.deviceModel || "");
  screenshots.forEach((file) => form.append("screenshots", file, file.name));

  return apiUpload("/feedback", form);
}
